var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CallStore',{ref:"callStore"}),_c('CallTakerStore',{ref:"callTakerStore"}),_c('TwilioSyncStore',{ref:"twilioSyncStore"}),_c('h1',[_vm._v("Phone Debug Page")]),_c('CallTakers'),_c('PhoneDebugTable',{attrs:{"syncClient":_vm.syncClient}}),_c('CallStats')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }